import { Handle, Position } from "@xyflow/react";
import { StepIcon } from "../StepIcon";
import { formatDuration } from "../executionTimeline";

// Un nodo del mapa de la corrida. Lo que lo distingue del nodo del editor es
// que carga lo que pasó: cuántas veces corrió, cuánto sumó y qué costó.

const RAN_TONE = {
  completed: "border-emerald-500/40 bg-emerald-500/5",
  failed: "border-rose-500/50 bg-rose-500/10",
  running: "border-blue-500/50 bg-blue-500/10 animate-pulse",
};

const HANDLE = { background: "#52525b", width: 6, height: 6, border: "none" };

export default function RunMapNode({ data, selected }) {
  const tone = data.ran
    ? RAN_TONE[data.lastStatus] || "border-white/15 bg-zinc-900"
    : // Los que no corrieron van punteados y apagados: están para dar
      // contexto, no para leerse como parte de la corrida.
      "border-dashed border-white/10 bg-transparent opacity-50";

  return (
    <div
      className={`w-44 rounded-lg border px-2.5 py-2 transition-shadow ${tone} ${
        selected ? "ring-2 ring-violet-500/60" : ""
      }`}
    >
      <Handle type="target" position={Position.Left} style={HANDLE} />

      <div className="flex items-start gap-2">
        <span className="mt-0.5 shrink-0">
          <StepIcon step={{ data: { step_type: data.stepType } }} size={14} />
        </span>
        <div className="min-w-0 flex-1">
          <div className="truncate text-[11px] font-medium text-gray-100">{data.name}</div>
          <div className="truncate text-[9px] text-gray-500">{data.stepType}</div>
        </div>
        {data.runs > 1 && (
          <span className="shrink-0 rounded bg-violet-500/20 px-1 py-0.5 text-[9px] font-semibold text-violet-200">
            ×{data.runs}
          </span>
        )}
      </div>

      {data.ran ? (
        <div className="mt-1.5 flex items-center gap-2 text-[9px] text-gray-500">
          <span className="font-mono text-gray-600">#{data.firstSeq}</span>
          <span>{formatDuration(data.totalMs)}</span>
          {data.coins > 0 && <span className="text-amber-300/80">{data.coins}c</span>}
          {data.failed > 0 && <span className="text-rose-400">{data.failed} failed</span>}
        </div>
      ) : (
        <div className="mt-1.5 truncate text-[9px] text-gray-600">
          {data.skippedReason === "not_taken"
            ? `left out by ${data.decidedBy || "a condition"}`
            : "never reached"}
        </div>
      )}

      <Handle type="source" position={Position.Right} style={HANDLE} />
    </div>
  );
}
